import {
  IconButton,
  PencilBarIcon,
  Tooltip,
} from '@frontend/legacy-components';

type EditMappingButtonProps = {
  isDisabled: boolean;
  disabledReason?: string;
  onEnterMappingMode: () => void;
};

const EDIT_LABEL = 'Edit mapping';

export const EditMappingButton = ({
  isDisabled,
  disabledReason,
  onEnterMappingMode,
}: EditMappingButtonProps) => (
  <Tooltip
    placement="top"
    label={isDisabled ? disabledReason : EDIT_LABEL}
    shouldWrapChildren={isDisabled}
  >
    <IconButton
      size="sm"
      aria-label={isDisabled && disabledReason ? disabledReason : EDIT_LABEL}
      isDisabled={isDisabled}
      onClick={onEnterMappingMode}
    >
      <PencilBarIcon boxSize={2.5} />
    </IconButton>
  </Tooltip>
);
EditMappingButton.displayName = 'EditMappingButton';
